import { render, staticRenderFns } from "./result-item.vue?vue&type=template&id=7e510805"
import script from "./result-item.vue?vue&type=script&lang=js"
export * from "./result-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e510805')) {
      api.createRecord('7e510805', component.options)
    } else {
      api.reload('7e510805', component.options)
    }
    module.hot.accept("./result-item.vue?vue&type=template&id=7e510805", function () {
      api.rerender('7e510805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/result-item.vue"
export default component.exports